export default {
    numberFormat: (value, decimals) => {
        value = (!value?0:value);
        decimals = (!decimals?0:decimals);
        const rounded =  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
        return '$ '+rounded.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    percentage: (value) => {
        return Math.round(value) + ' %'
    },
    numeric: (value, decimals) => {
        value = (!value?0:value);
        decimals = (!decimals?0:decimals);
        const rounded =  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
        return rounded.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
}